import { SvgIcon } from "@material-ui/core";
import { SvgIconProps } from "@material-ui/core/SvgIcon/SvgIcon";
import React from "react";
import pure from "recompose/pure";

const DashboardsIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M36 12C16.1177 12 0 28.1177 0 48V57C0 60.3137 2.68588 63 5.99959 63C11.5237 63 17.4086 63 22.5 63C24.1569 63 25.5 61.6569 25.5 60C25.5 58.3432 24.1569 57 22.5 57H6V48C6 35.5737 16.0736 25.5 28.5 25.5C34.0687 25.5 39.1581 27.5191 43.0876 30.8689C44.3485 31.9438 46.242 31.793 47.3169 30.5321C48.3917 29.2712 48.2409 27.3777 46.98 26.3029C42.0057 22.0624 35.5483 19.5 28.5 19.5C27.7843 19.5 27.0748 19.5264 26.3723 19.5782C29.3943 18.5549 32.6324 18 36 18C52.5686 18 66 31.4315 66 48V57C61 57 54.5 57 49.5 57C47.8432 57 46.5 58.3431 46.5 60C46.5 61.6569 47.8432 63 49.5 63H66C69.3137 63 72 60.3137 72 57V48C72 28.1177 55.8823 12 36 12Z"
      fill="white"
    />
    <path
      d="M55.8 33.6C57.1255 34.5941 57.3941 36.4745 56.4 37.8L45.15 52.8C44.1559 54.1255 42.2755 54.3941 40.95 53.4C39.6245 52.4059 39.3559 50.5255 40.35 49.2L51.6 34.2C52.5941 32.8745 54.4745 32.6059 55.8 33.6Z"
      fill="white"
    />
    <path
      d="M33 60C33 58.3431 34.3431 57 36 57C37.6569 57 39 58.3431 39 60C39 61.6569 37.6569 63 36 63C34.3431 63 33 61.6569 33 60Z"
      fill="white"
    />
  </SvgIcon>
);
DashboardsIcon.displayName = "DashboardsIcon";
DashboardsIcon.muiName = "SvgIcon";

export default pure(DashboardsIcon);
